var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
import _cloneDeep from "lodash/cloneDeep";
import { LifeCycleEventName } from "../constants/sdk";
import LoggingModule from "../modules/logging-module";
import BasePlugin from "./BasePlugin";
const DEFAULT_MAP = Object.keys(LifeCycleEventName).reduce((map, key) => {
  const event = LifeCycleEventName[key];
  map[event] = {};
  return map;
}, {});
class DefaultEventPlugin extends BasePlugin {
  constructor() {
    super(...arguments);
    this.addEventListener = (eventName, id, callback) => {
      var _a2, _b2;
      LoggingModule.info("[DefaultEventPlugin]: addEventListener");
      if ((_b2 = (_a2 = this._registeredCallbackMap) == null ? void 0 : _a2[eventName]) == null ? void 0 : _b2[id]) {
        LoggingModule.error("[DefaultEventPlugin]: addEventListener - id for this event callback has been used");
        return;
      }
      this._registeredCallbackMap[eventName][id] = callback;
    };
    this.removeEventListener = (eventName, id) => {
      var _a2, _b2;
      LoggingModule.info("[DefaultEventPlugin]: removeEventListener");
      if (!((_b2 = (_a2 = this._registeredCallbackMap) == null ? void 0 : _a2[eventName]) == null ? void 0 : _b2[id])) {
        return;
      }
      delete this._registeredCallbackMap[eventName][id];
    };
    // fetch consent
    this[_a] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.beforeFetchUserInfo}`);
      void this._triggerEvent(LifeCycleEventName.beforeFetchUserInfo, event);
    };
    this[_b] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.afterFetchUserInfo}`);
      void this._triggerEvent(LifeCycleEventName.afterFetchUserInfo, event);
    };
    // fetch consent
    this[_c] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.beforeFetchConsentData}`);
      void this._triggerEvent(LifeCycleEventName.beforeFetchConsentData, event);
    };
    this[_d] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.afterFetchConsentData}`);
      void this._triggerEvent(LifeCycleEventName.afterFetchConsentData, event);
    };
    // fetch notification
    this[_e] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.beforeFetchNotificationData}`);
      void this._triggerEvent(LifeCycleEventName.beforeFetchNotificationData, event);
    };
    this[_f] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.afterFetchNotificationData}`);
      void this._triggerEvent(LifeCycleEventName.afterFetchNotificationData, event);
    };
    // update record
    this[_g] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.beforeUpdateRecords}`);
      void this._triggerEvent(LifeCycleEventName.beforeUpdateRecords, event);
    };
    this[_h] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.afterUpdateRecords}`);
      void this._triggerEvent(LifeCycleEventName.afterUpdateRecords, event);
    };
    // notify
    this[_i] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.beforeNotify}`);
      void this._triggerEvent(LifeCycleEventName.beforeNotify, event);
    };
    this[_j] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.afterNotify}`);
      void this._triggerEvent(LifeCycleEventName.afterNotify, event);
    };
    // removeNotification
    this[_k] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.beforeRemoveNotification}`);
      void this._triggerEvent(LifeCycleEventName.beforeRemoveNotification, event);
    };
    this[_l] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.afterRemoveNotification}`);
      void this._triggerEvent(LifeCycleEventName.afterRemoveNotification, event);
    };
    // third party approve
    this[_m] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.beforeThirdPartyApprove}`);
      void this._triggerEvent(LifeCycleEventName.beforeThirdPartyApprove, event);
    };
    this[_n] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.afterThirdPartyApprove}`);
      void this._triggerEvent(LifeCycleEventName.afterThirdPartyApprove, event);
    };
    // third party reject
    this[_o] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.beforeThirdPartyReject}`);
      void this._triggerEvent(LifeCycleEventName.beforeThirdPartyReject, event);
    };
    this[_p] = (event) => {
      LoggingModule.info(`[DefaultEventPlugin]: ${LifeCycleEventName.afterThirdPartyReject}`);
      void this._triggerEvent(LifeCycleEventName.afterThirdPartyReject, event);
    };
    this.destruct = () => {
      Object.keys(LifeCycleEventName).forEach((key) => {
        const event = LifeCycleEventName[key];
        Object.keys(this._registeredCallbackMap[event]).forEach((id) => {
          delete this._registeredCallbackMap[event][id];
        });
        this._registeredCallbackMap[event] = {};
      });
    };
  }
  init() {
    this._registeredCallbackMap = _cloneDeep(DEFAULT_MAP);
  }
  _triggerEvent(eventName, event) {
    return __async(this, null, function* () {
      LoggingModule.info("[DefaultEventPlugin]: triggerEvent");
      const promises = [];
      Object.values(this._registeredCallbackMap[eventName]).forEach((callback) => {
        if (typeof callback === "function") {
          const _a2 = event, { plugin } = _a2, rest = __objRest(_a2, ["plugin"]);
          promises.push(
            callback(__spreadValues({
              plugin
            }, _cloneDeep(rest)))
          );
        }
      });
      try {
        yield Promise.all(promises);
      } catch (e) {
        LoggingModule.warn("[DefaultEventPlugin]: plugin callback error", e);
      }
    });
  }
}
_a = LifeCycleEventName.beforeFetchUserInfo, _b = LifeCycleEventName.afterFetchUserInfo, _c = LifeCycleEventName.beforeFetchConsentData, _d = LifeCycleEventName.afterFetchConsentData, _e = LifeCycleEventName.beforeFetchNotificationData, _f = LifeCycleEventName.afterFetchNotificationData, _g = LifeCycleEventName.beforeUpdateRecords, _h = LifeCycleEventName.afterUpdateRecords, _i = LifeCycleEventName.beforeNotify, _j = LifeCycleEventName.afterNotify, _k = LifeCycleEventName.beforeRemoveNotification, _l = LifeCycleEventName.afterRemoveNotification, _m = LifeCycleEventName.beforeThirdPartyApprove, _n = LifeCycleEventName.afterThirdPartyApprove, _o = LifeCycleEventName.beforeThirdPartyReject, _p = LifeCycleEventName.afterThirdPartyReject;
var DefaultEventPlugin_default = DefaultEventPlugin;
export {
  DefaultEventPlugin_default as default
};
